import { Box, Container, Typography } from '@mui/material';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const GalleryPageLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  const cols = isMobile ? 1 : isTablet ? 2 : 3;
  
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography 
          variant="h1" 
          sx={{ 
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            fontWeight: 700,
            color: '#2c3e50',
            mb: 2,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
        >
          Art Gallery
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            fontSize: { xs: '1.1rem', md: '1.25rem' },
            color: '#7f8c8d',
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic'
          }}
        >
          A collection of Philip Payne's artwork
        </Typography>
      </Box>
      
      <ImageList 
        sx={{ 
          width: '100%', 
          height: 'auto',
          // Masonry-style layout
          columnCount: {
            xs: '1 !important',
            sm: '2 !important',
            md: '3 !important'
          }
        }} 
        variant='masonry'
        cols={cols}
        gap={16}
      >
        {itemData.map((item) => (
          <ImageListItem 
            key={item.img}
            sx={{
              overflow: 'hidden',
              borderRadius: 2,
              cursor: 'pointer',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
              }
            }}
          >
            <img
              src={`${item.img}`}
              srcSet={`${item.img}`}
              alt={item.title}
              loading="lazy"
              style={{
                display: 'block',
                width: '100%',
                height: 'auto'
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Container>
  );
}

const itemData = [
  {
    img: '/gallery-1.jpeg',
    title: 'Gallery 1',
  },
  {
    img: '/gallery-2.jpeg',
    title: 'Gallery 2',
  },
  {
    img: '/gallery-3.jpeg',
    title: 'Gallery 3',
  },
  {
    img: '/gallery-4.jpeg',
    title: 'Gallery 4',
  },
  {
    img: '/gallery-5.jpeg',
    title: 'Gallery 5',
  },
  {
    img: '/gallery-6.jpeg',
    title: 'Gallery 6',
  },
  {
    img: '/gallery-7.jpeg',
    title: 'Gallery 7',
  },
  {
    img: '/gallery-8.jpeg',
    title: 'Gallery 8',
  },
  {
    img: '/gallery-9.jpeg',
    title: 'Gallery 9',
  },
];

export default GalleryPageLayout;